import { Navigate, Route, Routes } from 'react-router-dom'
import NotificationLogs from './NotificationLogs'

export default function NotificationLogsRoutes() {
    return (
        <Routes>
            <Route index element={<NotificationLogs />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
